export { default } from './thumb-list-item.jsx';